<ng-template #rt let-r="result" let-t="term">
  <ngb-highlight [result]="r.HSN_CODE + '  ' + r.DDC_CODE + ' - ' + r.TRADE_NAME" [term]="t"></ngb-highlight>
</ng-template>

<app-page-header [heading]="'Rate Sheet'" [icon]="'fa-money'" style="height:100px;"></app-page-header>
<div *ngIf="user_rights.ADD == '1'" class="page-panel">
  <div class="row">
    <div class="col-6 form-group">
      <label>Supplier Name</label><span class="text-danger">&nbsp;*</span>
      <ngx-select-dropdown (change)="getVendor($event)" [(ngModel)]="vendor_data"
                           [config]="utils.dropConfig({displayKey: 'VENDOR_NAME',placeholder: 'Select Supplier',searchOnKey: 'VENDOR_NAME'})"
                           [multiple]="false"
                           [options]="vendor_options" class="form-control  select-dropdown"
                           name="sel_tpa_receiver"></ngx-select-dropdown>
    </div>
    <div class="col-6 form-group">
      <label>Item</label><span class="text-danger">&nbsp;*</span>
      <input (selectItem)="set_item_medicine($event)" [(ngModel)]="supplier_price.medicine_data"
             [class.is-invalid]="searchFailed" [inputFormatter]="formatter"
             [ngModelOptions]="{standalone: true}" [ngbTypeahead]="medicine_search" [resultTemplate]="rt"
             class="form-control"
             id="typeahead-http" placeholder="Search Particular Name...."
             type="text"/>
    </div>

    <div class="col-6 form-group">
      <label for="date">From Date</label>
      <input (ngModelChange)="supplier_price.fromdate = $event" [max]="getToday()"
             [ngModel]="supplier_price.fromdate | date:'yyyy-MM-dd'"
             class="form-control " id="date" name="date" type="date">

    </div>
    <div class="col-6 form-group">
      <label for="date">To Date</label>
      <input (ngModelChange)="supplier_price.todate = $event" [ngModel]="supplier_price.todate | date:'yyyy-MM-dd'"
             class="form-control "
             id="supplier_price.todate" name="supplier_price.todate" type="date">
    </div>

    <div class="col-6 form-group">
      <label>Price</label><span class="text-danger">&nbsp;*</span>
      <input [(ngModel)]="supplier_price.item_price" class="form-control " name="item_price"
             type="text">

    </div>

    <div class="col-6 form-group ">
      <label>VAT Price</label>
      <div>
        <label class="checkbox-inline">
          <input (click)="selectVatprice(1)" [checked]="supplier_price.vat_price == 1" id="Yes" name="vat_price"
                 type="radio"
                 value="1">&nbsp;&nbsp;Yes&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        </label>

        <label class="checkbox-inline">
          <input (click)="selectVatprice(0)" [checked]="supplier_price.vat_price == 0" id="No" name="vat_price"
                 type="radio"
                 value="0">&nbsp;&nbsp;No
        </label>
      </div>
    </div>

    <div class="clearfix"></div>
    <div class="col-lg-12">
      <div style="display: flex;justify-content: flex-end">
        <button (click)="saveSupplierPrice();" *ngIf="user_rights.ADD == '1'"
                class="btn btn-info btn-sm ng-star-inserted"
                type="button">&nbsp;Save&nbsp;
        </button>&nbsp;&nbsp;&nbsp;
      </div>
    </div>
  </div>
</div>

